import './detail-stage.scss';

import Swiper from 'swiper';
import { Pagination, Navigation, A11y, Thumbs } from 'swiper/modules';

class DetailStage {
    constructor ($element) {
        this.$detailStageSliderContainer = $element;
        this.$detailStageSlider = this.$detailStageSliderContainer.querySelector('[data-detail-stage-slider="slider"]');
        this.$slides = this.$detailStageSlider?.querySelectorAll('[data-detail-stage-slider="slide"]');
        this.$detailStageSliderThumbs = this.$detailStageSliderContainer.querySelector('[data-detail-stage-slider-thumbs="slider"]');
        this.$thumbSlides = this.$detailStageSliderThumbs?.querySelectorAll('[data-detail-stage-slider-thumbs="slide"]');
        this.slider = null;
        this.$slidePrev = this.$detailStageSliderContainer.querySelector('.slider-controls__prev');
        this.$slideNext = this.$detailStageSliderContainer.querySelector('.slider-controls__next');
        this.$pagination = this.$detailStageSliderContainer.querySelector('.detail-stage__slider-pagination');
        this.sliderThumbs = null;
    }

    initialize () {
        if (this.$slides) {
            if (this.$slides.length > 1) {
                this.initSlider();
                this.resizeSlider();
            }
        }

        this.moveButtons();
    }

    initSlider () {
        this.sliderThumbs = new Swiper(this.$detailStageSliderThumbs, {
            modules: [Pagination, A11y, Thumbs],
            slidesPerView: 'auto',
            freeMode: true,
            speed: 500,
            slideClass: 'detail-stage__slider-thumbs-item',
            wrapperClass: 'detail-stage__slider-thumbs-items',
            watchSlidesProgress: true,
            breakpoints: {
                1024: {
                    direction: 'vertical'
                }
            }
        });

        this.slider = new Swiper(this.$detailStageSlider, {
            modules: [Pagination, Navigation, A11y, Thumbs],
            slidesPerView: 1,
            speed: 500,
            spaceBetween: 10,
            slideClass: 'detail-stage__slider-item',
            wrapperClass: 'detail-stage__slider-items',
            pagination: {
                el: this.$pagination,
                type: 'progressbar'
            },
            navigation: {
                nextEl: this.$slideNext,
                prevEl: this.$slidePrev,
                disabledClass: 'slider-controls__disabled'
            },
            thumbs: {
                swiper: this.sliderThumbs
            },
            breakpoints: {
                768: {
                    direction: 'vertical',
                    spaceBetween: 0
                }
            },
            on: {
                slideChangeTransitionStart: () => {
                    const $progressBar = this.$detailStageSliderContainer.querySelector('.slider-pagination');
                    $progressBar.classList.add('is--active');
                },
                slideChangeTransitionEnd: () => {
                    const $progressBar = this.$detailStageSliderContainer.querySelector('.slider-pagination');
                    $progressBar.classList.remove('is--active');
                }
            }
        });

        if (window.innerWidth >= 1024) {
            this.setSliderHeight();
        }
    }

    setSliderHeight () {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1024) {
            for (let i = 0; i < this.$slides.length; i++) {
                const $slide = this.$slides[i];
                const $slideImage = $slide.querySelector('.detail-stage__slider-item-image');
                const slideImageHeight = $slideImage.offsetHeight;
                const slidePadding = parseInt(window.getComputedStyle($slide).paddingTop.replace('px', '')) + parseInt(window.getComputedStyle($slide).paddingBottom.replace('px', ''));
                const slideHeight = slideImageHeight + slidePadding;
                this.$detailStageSlider.style.maxHeight = slideHeight + 'px';
            }

            for (let i = 0; i < this.$thumbSlides.length; i++) {
                const $slide = this.$thumbSlides[i];
                const $slideImage = $slide.querySelector('.detail-stage__slider-thumbs-item-image');
                const slideImageHeight = $slideImage.offsetHeight;
                const slidePadding = parseInt(window.getComputedStyle($slide).paddingTop.replace('px', '')) + parseInt(window.getComputedStyle($slide).paddingBottom.replace('px', ''));
                const slideHeight = slideImageHeight + slidePadding;
                $slide.style.maxHeight = slideHeight + 'px';
            }
        } else {
            this.$detailStageSlider.style.maxHeight = 'none';
        }
    }

    resizeSlider () {
        window.resizeHandler.customFunctions.push(() => {
            const windowWidth = window.innerWidth;
            if (windowWidth >= 1024) {
                this.setSliderHeight();
            } else {
                this.$detailStageSlider.style.maxHeight = '';

                for (let i = 0; i < this.$thumbSlides.length; i++) {
                    this.$thumbSlides[i].style.maxHeight = '';
                }
            }
        });
    }

    moveButtons () {
        const $select = this.$detailStageSliderContainer.querySelector('.ss-main.detail-stage__sizes-select .ss-content');
        const $buttons = this.$detailStageSliderContainer.querySelectorAll('.detail-stage__sizes-cta');

        if ($select && $buttons.length > 0) {
            for (let i = 0; i < $buttons.length; i++) {
                $select.appendChild($buttons[i]);
            }
        }
    }
}

export { DetailStage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $detailStageSliders = $context.querySelectorAll('[data-detail-stage-slider="root"]');
        if ($detailStageSliders.length > 0) {
            $detailStageSliders.forEach((detailStageSlider) => {
                const $detailStageSlider = new DetailStage(detailStageSlider);
                $detailStageSlider.initialize();
            });
        }
    }
});
